/* eslint-disable */
export default {
  None: 'None',
  MatchCase: 'MatchCase',
  MatchWholeWord: 'MatchWholeWord',
  PreserveCapitalization: 'PreserveCapitalization',
  StartsWith: 'StartsWith'
};

